import { render, staticRenderFns } from "./ReservationDetail.vue?vue&type=template&id=00a185f9&scoped=true"
import script from "./ReservationDetail.vue?vue&type=script&lang=js"
export * from "./ReservationDetail.vue?vue&type=script&lang=js"
import style0 from "./ReservationDetail.vue?vue&type=style&index=0&id=00a185f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a185f9",
  null
  
)

export default component.exports